import React from 'react';
import { Col, Row } from '@yme/atoms/grid';
import { Skeleton, OrderSummarySkeleton } from '@yme/common/components/skeletons';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { getSkeletonHeight } from './helpers';
import { FromWrapper } from './styled';
export function FormWrapperWithOrderSkeleton({ step }) {
    const { isInfiniteDesktopView, isMobileView } = useWindowSize();
    return (React.createElement(FromWrapper, null,
        React.createElement(Row, null,
            React.createElement(Col, { lg: 7 },
                React.createElement(FlexWrapper, { flexDirection: "column", height: "100%" },
                    React.createElement(Skeleton, { skeletonProps: {
                            height: getSkeletonHeight(step, isMobileView),
                        }, wrapperProps: {
                            mlS: -16,
                            mrS: -16,
                            mlM: 0,
                            mrM: 0,
                        } }),
                    !isInfiniteDesktopView && React.createElement(OrderSummarySkeleton, null))),
            isInfiniteDesktopView && (React.createElement(Col, { lg: 5 },
                React.createElement(OrderSummarySkeleton, null))))));
}
